function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from "react";
import { Divider, ToggleButton, ToggleButtonGroup } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function ApartmentToggle(_ref) {
  var _config$projects, _config$projects2;
  var apartments = _ref.apartments,
    apartmentUpdate = _ref.apartmentUpdate,
    apartmentTypes = _ref.apartmentTypes,
    config = _ref.config;
  var _useState = useState(apartments),
    _useState2 = _slicedToArray(_useState, 2),
    formats = _useState2[0],
    setFormats = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    show = _useState4[0],
    setShow = _useState4[1];
  var handleFormat = function handleFormat(event, newFormats) {
    setFormats(newFormats);
  };
  useEffect(function () {
    apartmentUpdate(formats);
  }, [formats]);
  return /*#__PURE__*/_jsxs("div", {
    className: "mb-16",
    children: [/*#__PURE__*/_jsxs(ToggleButtonGroup, {
      color: config === null || config === void 0 ? void 0 : config.primaryColor,
      value: formats,
      onChange: handleFormat,
      "aria-label": "text formatting",
      sx: {
        display: "grid",
        gridGap: "4px",
        color: "purple",
        gridTemplateColumns: "repeat(3, 1fr)",
        height: "80px",
        overflowY: "scroll",
        margin: "0px 0px 16px 0px"
      },
      className: "scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-300 ".concat(config === null || config === void 0 || (_config$projects = config.projects) === null || _config$projects === void 0 || (_config$projects = _config$projects.moduleConfig) === null || _config$projects === void 0 ? void 0 : _config$projects.fontBody),
      children: [apartmentTypes.map(function (type, index) {
        return index < 4 ? /*#__PURE__*/_jsx(ToggleButton, {
          value: type,
          size: "small",
          color: "primary",
          style: {
            border: "1px solid gray",
            margin: "4px",
            borderRadius: "80px",
            padding: "0px",
            fontSize: "16px",
            color: formats.includes(type) ? config === null || config === void 0 ? void 0 : config.primaryColor : "gray"
          },
          "aria-label": type,
          children: type
        }, type) : /*#__PURE__*/_jsx(ToggleButton, {
          value: type,
          size: "small",
          color: "primary",
          style: {
            border: "1px solid gray",
            margin: "4px",
            borderRadius: "80px",
            padding: "0px",
            fontSize: "16px",
            display: show ? "none" : "inline",
            color: formats.includes(type) ? config === null || config === void 0 ? void 0 : config.primaryColor : "gray"
          },
          "aria-label": type,
          children: type
        }, type);
      }), /*#__PURE__*/_jsx("p", {
        onClick: function onClick() {
          return setShow(!show);
        },
        className: "m-auto text-primary font-medium text-md align-bottom cursor-pointer ".concat(config === null || config === void 0 || (_config$projects2 = config.projects) === null || _config$projects2 === void 0 || (_config$projects2 = _config$projects2.moduleConfig) === null || _config$projects2 === void 0 ? void 0 : _config$projects2.fontBody),
        children: !show ? "Show Less" : "Show More"
      })]
    }), /*#__PURE__*/_jsx(Divider, {
      sx: {
        margin: "12px 0px 0px 0px"
      }
    })]
  });
}